const ArrowCornerDownRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.75 4.75V13.25C3.75 14.3546 4.64543 15.25 5.75 15.25H19.25M16.25 11.25L20.25 15.25L16.25 19.25"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowCornerDownRight
